<template>
  <BaseNewQuote :title="header">
      <InboundInfo v-if="info" class="inbound-info_flow-inner" @clickPlan="$emit('clickPlan')" />
      <div class="quote__information">
        <slot name="destination"></slot>
        <AdultsDisplay :adults="adults" :children="children" :date-start="dateStart" :date-end="dateEnd" />
      </div>
    <QuoteAdditionals
      :additionals="additionals || defaultAdditionals">
        <template v-slot:title>
          <div class="quote__header-top">
            <div class="quote__title">
              {{ $t(additionalMultilangTitle) }}
            </div>
          <span class="quote__discount">{{ getDiscountTitle }} &lrm;-{{ (discount * 100 / (totalPrice + discount)).toFixed(0) }}%</span>
        </div>
        </template>
        <BaseAccordion
          v-for="(additional, index) of (sortedAdditionals || defaultAdditionals)"
          :key="index"
          :disabled="!additional.description && !(additional.benefits && additional.benefits.length)">
          <template v-slot:name >
            {{ additional.name }}
          </template>
          <template v-slot:content>
            <div class="quote__inclusive-ng">
              <div class="quote__inclusive-optional">{{ additional.description }}</div>
              <div class="quote__subcover" v-if="additional.benefits && additional.benefits.length">
                <div class="quote__subcover-item" v-for="(item, index) of additional.benefits" :key="index">
                  <div class="quote__subcover-describe">
                    <span>{{item.name}}</span>. {{ item.description }}
                  </div>
                  <div class="quote__subcover-price" v-if="item.price && String(item.price).toLowerCase() !== 'yes' && String(item.price).toLowerCase() !== 'no'">
                    <span>{{ $t('qic_quote_insurance_limit') }}</span> {{ item.price }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </BaseAccordion>
    </QuoteAdditionals>
    <QuoteCheckoutSimple
      :total-price="totalPrice"
      :total-price-without-discount="discount + totalPrice"
      :footer-text="$t('qic_prequote_disclaimer')"
      @onPayment="onSubmit"/>
  </BaseNewQuote>
</template>

<script>
import BaseAccordion from '../BaseAccordion.vue'
import AdultsDisplay from '../landing/AdultsDisplay.vue'
import BaseNewQuote from './BaseNewQuote.vue'
import QuoteAdditionals from './QuoteAdditionals.vue'
import QuoteCheckoutSimple from './QuoteCheckoutSimple.vue'
import InboundInfo from '../InboundInfo.vue'
export default {
  name: 'PreQuote',
  props: [
    'additionals',
    'additionalMultilangTitle',
    'quoteIncludes',
    'adults',
    'children',
    'dateStart',
    'dateEnd',
    'header',
    'totalPrice',
    'discount',
    'discountsArray',
    'info'
  ],
  components: {
    BaseNewQuote,
    BaseAccordion,
    QuoteCheckoutSimple,
    QuoteAdditionals,
    AdultsDisplay,
    InboundInfo
  },
  data () {
    return {
      defaultAdditionals: [
        {
          id: '1',
          name: 'Emergency Medical Cover',
          benefits: []
        },
        {
          id: '2',
          name: 'Travel Inconvenience Cover',
          benefits: [
            {
              price: '100',
              description: 'Going off the paved roads, no problem, this cover will insure your car on non-metal roads (not the dunes or similar terrains)'
            },
            {
              price: '200',
              description: 'Going off the paved roads, no problem, this cover will insure your car on non-metal roads (not the dunes or similar terrains)'
            }
          ]
        }
      ]
    }
  },
  computed: {
    getDiscountTitle () {
      if (Array.isArray(this.discountsArray) && this.discountsArray.length === 1) {
        return this.discountsArray[0].name
      }
      return this.$t('qic_prequote_online_discount')
    },
    sortedAdditionals () {
      return [...this.additionals].sort((a, b) => a.description ? -1 : 1)
    }
  },
  methods: {
    onSubmit () {
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss">
  .inbound-additional_price {
    display: flex;
    justify-content: space-between;
    line-height: 24px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(28, 28, 28, 1);
    .description-cover {
      width: 80%;
      color: rgba(82, 108, 130, 0.8);
    }
    .price-cover {
      font-size: 14px;
      line-height: 24px;
      font-weight: 400;
      color: rgba(28, 28, 28, 1);
    }
  }
</style>
